import React from 'react';

const FinancialServices = () => {
  return (
    <div className="page">
      <h1>Financial Services Solutions</h1>
      {/* Content will be added later */}
    </div>
  );
};

export default FinancialServices; 